"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luminanceJs = require("luminance-js");

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _reactSelect = _interopRequireDefault(require("react-select/dist/react-select.cjs"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {
  inputsHours: function inputsHours(props) {
    return _objectSpread({
      display: 'flex',
      outline: 'none',
      padding: '0 10px',
      fontSize: 14,
      borderRadius: 5,
      alignItems: 'center'
    }, props.style.inputsHours);
  },
  colon: function colon(props) {
    return _objectSpread({
      display: 'flex',
      alignItems: 'center',
      paddingRight: '5px'
    }, props.style.colon);
  },
  timeButtonImage: function timeButtonImage(props) {
    return _objectSpread({
      width: 25
    }, props.style.timeButtonImage);
  },
  '@global': function global(props) {
    return _objectSpread({
      '.basic-single-meridiem': {
        display: 'flex',
        alignItems: 'center'
      }
    }, props.style.global);
  }
};

var Time =
/*#__PURE__*/
function (_Component) {
  _inherits(Time, _Component);

  function Time() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Time);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Time)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isClearable: true,
      isSearchable: true,
      hours: [],
      hoursValue: [],
      minutes: [],
      minutesValue: [],
      meridiem: [{
        value: 'AM',
        label: 'AM'
      }, {
        value: 'PM',
        label: 'PM'
      }],
      meridiemValue: []
    });

    _defineProperty(_assertThisInitialized(_this), "minTwoDigits", function (value) {
      return (value < 10 ? '0' : '') + value;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeHours", function (hoursValue) {
      var _this$props = _this.props,
          getSelectedHours = _this$props.getSelectedHours,
          systemUS = _this$props.systemUS;

      _this.setState({
        hoursValue: hoursValue
      }, function () {
        getSelectedHours(hoursValue.value, systemUS ? _this.state.meridiemValue.value : null);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeMinutes", function (minutesValue) {
      var getSelectedMinutes = _this.props.getSelectedMinutes;

      _this.setState({
        minutesValue: minutesValue
      }, function () {
        getSelectedMinutes(minutesValue.value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeMeridiem", function (meridiemValue) {
      _this.setState({
        meridiemValue: meridiemValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (element) {
      var _this$props2 = _this.props,
          style = _this$props2.style,
          isMobile = _this$props2.isMobile; // TODO add props with translated

      var noResult = 'Pas de résultat.';
      var customStyles = {
        clearIndicator: function clearIndicator(provided) {
          return _objectSpread({}, provided, {
            display: 'none'
          }, style.clearIndicator);
        },
        container: function container(provided) {
          return _objectSpread({}, provided, {}, style.container);
        },
        control: function control(provided) {
          return _objectSpread({}, provided, {
            display: 'flex',
            border: 'none',
            backgroundColor: 'none',
            borderRadius: 'none',
            borderStyle: 'none',
            borderWidth: 'none'
          }, style.control);
        },
        dropdownIndicator: function dropdownIndicator(provided) {
          return _objectSpread({}, provided, {
            display: 'none'
          }, style.dropdownIndicator);
        },
        group: function group(provided) {
          return _objectSpread({}, provided, {}, style.group);
        },
        groupHeading: function groupHeading(provided) {
          return _objectSpread({}, provided, {}, style.groupHeading);
        },
        indicatorsContainer: function indicatorsContainer(provided) {
          return _objectSpread({}, provided, {}, style.indicatorsContainer);
        },
        indicatorSeparator: function indicatorSeparator(provided) {
          return _objectSpread({}, provided, {
            display: 'none'
          }, style.indicatorSeparator);
        },
        input: function input(provided) {
          return _objectSpread({}, provided, {}, style.input);
        },
        loadingIndicator: function loadingIndicator(provided) {
          return _objectSpread({}, provided, {}, style.loadingIndicator);
        },
        loadingMessage: function loadingMessage(provided) {
          return _objectSpread({}, provided, {}, style.loadingMessage);
        },
        menu: function menu(provided) {
          return _objectSpread({}, provided, {
            top: isMobile ? provided.top : 'initial',
            position: isMobile ? 'absolute' : 'fixed',
            width: 'auto'
          }, style.menu);
        },
        menuList: function menuList(provided) {
          return _objectSpread({}, provided, {
            overflowX: 'hidden'
          }, style.menuList);
        },
        multiValue: function multiValue(provided) {
          return _objectSpread({}, provided, {}, style.multiValue);
        },
        multiValueLabel: function multiValueLabel(provided) {
          return _objectSpread({}, provided, {}, style.multiValueLabel);
        },
        multiValueRemove: function multiValueRemove(provided) {
          return _objectSpread({}, provided, {}, style.multiValueRemove);
        },
        noOptionsMessage: function noOptionsMessage(provided) {
          return _objectSpread({}, provided, {}, style.noOptionsMessage);
        },
        option: function option(provided) {
          return _objectSpread({}, provided, {
            '&:hover': {
              backgroundColor: style.first,
              color: (0, _luminanceJs.luminance)(style.first) > 0.5 ? '#333' : '#fff',
              cursor: 'pointer'
            }
          }, style.option);
        },
        placeholder: function placeholder(provided) {
          return _objectSpread({}, provided, {}, style.placeholder);
        },
        singleValue: function singleValue() {
          return _objectSpread({}, style.singleValue);
        },
        valueContainer: function valueContainer(provided) {
          return _objectSpread({}, provided, {
            display: 'flex',
            alignItems: 'center'
          }, style.valueContainer);
        }
      };
      return _react.default.createElement(_reactSelect.default, {
        menuPlacement: isMobile ? 'top' : 'auto',
        styles: customStyles,
        className: 'basic-single-' + element,
        classNamePrefix: 'select-' + element,
        name: element,
        isClearable: false,
        isSearchable: false,
        noOptionsMessage: function noOptionsMessage() {
          return noResult;
        },
        onChange: element === 'hours' ? _this.handleChangeHours : element === 'minutes' ? _this.handleChangeMinutes : _this.handleChangeMeridiem,
        value: _this.state[element + 'Value'],
        options: _this.state[element]
      });
    });

    return _this;
  }

  _createClass(Time, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props3 = this.props,
          getSelectedHours = _this$props3.getSelectedHours,
          getSelectedMinutes = _this$props3.getSelectedMinutes,
          systemUS = _this$props3.systemUS;
      var hours = [];
      var hoursValue = [];
      var minutes = [];
      var minutesValue = [];
      var meridiemValue = this.state.meridiem.find(function (meridiem) {
        return meridiem.value === (0, _moment.default)().format('A');
      }); // Treatment for hours

      if (systemUS) {
        // 12 hours format time
        for (var i = 1; i <= 12; i++) {
          var value = {
            value: i,
            label: i
          };
          hours.push(value);

          if (i === parseInt((0, _moment.default)().format('hh'))) {
            hoursValue.push(value);
          }
        }
      } else {
        // 24 hours format time
        for (var _i = 0; _i <= 23; _i++) {
          var _value = {
            value: this.minTwoDigits(_i),
            label: this.minTwoDigits(_i)
          };
          hours.push(_value);

          if (_i === parseInt((0, _moment.default)().format('HH'))) {
            hoursValue.push(_value);
          }
        }
      } // Treatment for minutes


      for (var _i2 = 0; _i2 <= 59; _i2++) {
        var _value2 = {
          value: this.minTwoDigits(_i2),
          label: this.minTwoDigits(_i2)
        };
        minutes.push(_value2);

        if (_i2 === parseInt((0, _moment.default)().format('mm'))) {
          minutesValue.push(_value2);
        }
      }

      this.setState({
        hours: hours,
        hoursValue: hoursValue,
        minutes: minutes,
        minutesValue: minutesValue,
        meridiemValue: systemUS ? meridiemValue : null
      }, function () {
        getSelectedHours(_this2.state.hoursValue[0].value, meridiemValue.value);
        getSelectedMinutes(_this2.state.minutesValue[0].value);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          classes = _this$props4.classes,
          image = _this$props4.image,
          systemUS = _this$props4.systemUS;
      console.log('calendar', image);
      return _react.default.createElement("div", {
        className: classes.inputsHours
      }, _react.default.createElement("img", {
        src: image,
        className: classes.timeButtonImage,
        alt: "time"
      }), this.renderInput('hours'), _react.default.createElement("span", {
        className: classes.colon
      }, ":"), this.renderInput('minutes'), systemUS && this.renderInput('meridiem'));
    }
  }]);

  return Time;
}(_react.Component);

var _default = (0, _reactJss.default)(styles)(Time);

exports.default = _default;